import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "d-flex align-items-center justify-content-center" }
const _hoisted_2 = { class: "card-title fw-light" }
const _hoisted_3 = {
  wrap: "",
  class: "bg-white p-4"
}
const _hoisted_4 = {
  key: 0,
  class: "mb-3"
}
const _hoisted_5 = {
  key: 0,
  class: "confirm_mail"
}
const _hoisted_6 = { key: 1 }
const _hoisted_7 = {
  key: 2,
  xs12: "",
  md12: ""
}
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = {
  xs12: "",
  "text-xs-right": ""
}
const _hoisted_10 = { class: "p-4 d-flex flex-column align-start" }

import { ref, computed, watch, onMounted } from 'vue'
import { checkMobile } from '../../utils/utils'
import MaterialCard from '../../materials/Card.vue'
import UserBlock from '../../../api/v2/models/user_block'
import UserForm from '../../../api/v2/forms/user_form'
import api from '../../../api/v2/api'
import { userState } from '../../stores/user'
import { headerState } from '../../stores/header'

const defaultAvt =
  'https://i0.wp.com/www.winhelponline.com/blog/wp-content/uploads/2017/12/user.png?resize=256%2C256&quality=100&ssl=1'


export default /*@__PURE__*/_defineComponent({
  __name: 'UserUpdateFormView',
  props: {
    showPreview: { type: Boolean, default: true },
    mode: { default: 'user_update' }
  },
  setup(__props: any) {

const props = __props

const mobile = ref(false)
const form = ref(new UserForm())
const image = ref<any>(defaultAvt)
const groups = ref<UserBlock[]>([])
const completeDialog = ref(false)

const user = computed(() => userState.user)
const isGuestUpdate = computed(() => props.mode == 'guest_update')
const errorMessage = computed(() => userState.errorMessage)
const isLoading = computed(() => userState.isLoading)
const schoolSetting = computed(() => headerState.schoolSetting)

const setUser = () => {
  if (user.value) {
    if (!user.value.isGuestExamOnly || user.value.unconfirmedEmail) {
      form.value.name = user.value.name
      form.value.email = user.value.email
    } else {
      form.value.name = ''
      form.value.email = ''
    }
    form.value.userBlockId = user.value.userBlockId
    if (user.value.image) {
      image.value = user.value.image.url
    } else {
      image.value = defaultAvt
    }
  }
}

const onFileChange = (e: Event) => {
  const target = e.target as HTMLInputElement
  const files = target.files || (e as any).dataTransfer?.files
  if (!files?.length) return
  createImage(files[0])
}

const createImage = (file: File) => {
  form.value.image = file

  const imageEl = new Image()
  const reader = new FileReader()
  reader.onload = (e) => {
    image.value = (e.target as any).result
  }
  reader.readAsDataURL(file)
}

const removeImage = (e: Event) => {
  image.value = ''
}

const onUpdate = async () => {
  const guestErrors: string[] = []
  if (!form.value.name || form.value.name.indexOf('guest_') != -1) {
    guestErrors.push('名前を変更してください')
  }
  if (!form.value.email || form.value.email.indexOf('guest_') != -1) {
    guestErrors.push('メールアドレスを変更してください')
  }
  if (!form.value.password) {
    guestErrors.push('パスワードを入力してください')
  }
  if (guestErrors.length > 0) {
    userState.setErrorMessage(guestErrors.join("<br>"))
    return
  }
  if (form.value.password && !form.value.isSamePass) {
    userState.setErrorMessage('パスワード（再入力）とパスワードの入力が一致しません')
    return
  }
  if (!isLoading.value) {
    await userState.updateUser({
      userForm: form.value
    })

    completeDialog.value = true
  }
}

watch(user, () => {
  setUser()
})

onMounted(async () => {
  mobile.value = checkMobile()
  groups.value = await api.userBlock.index()
  setUser()
  userState.getUser()
})

return (_ctx: any,_cache: any) => {
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_avatar = _resolveComponent("v-avatar")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_toolbar = _resolveComponent("v-toolbar")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.showPreview)
      ? (_openBlock(), _createBlock(_component_v_col, {
          key: 0,
          cols: "12",
          lg: "4"
        }, {
          default: _withCtx(() => [
            _createVNode(MaterialCard, { class: "v-card-profile" }, {
              offset: _withCtx(() => [
                _createVNode(_component_v_avatar, {
                  class: "mx-auto d-block",
                  size: "130"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_img, { src: image.value }, null, 8 /* PROPS */, ["src"])
                  ]),
                  _: 1 /* STABLE */
                })
              ]),
              default: _withCtx(() => [
                _createVNode(_component_v_card_text, { class: "text-xs-center" }, {
                  default: _withCtx(() => [
                    _createElementVNode("h4", _hoisted_2, _toDisplayString(form.value.name), 1 /* TEXT */)
                  ]),
                  _: 1 /* STABLE */
                })
              ]),
              _: 1 /* STABLE */
            })
          ]),
          _: 1 /* STABLE */
        }))
      : _createCommentVNode("v-if", true),
    _createVNode(_component_v_col, {
      cols: "12",
      lg: "8"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", null, [
            _createVNode(_component_v_text_field, {
              class: "purple-input",
              label: "名前",
              placeholder: "お名前を書いてください",
              modelValue: form.value.name,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.value.name) = $event))
            }, null, 8 /* PROPS */, ["modelValue"])
          ]),
          (!isGuestUpdate.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createElementVNode("input", {
                  type: "file",
                  onChange: onFileChange
                }, null, 32 /* NEED_HYDRATION */)
              ]))
            : _createCommentVNode("v-if", true),
          _createElementVNode("div", null, [
            (user.value && user.value.unconfirmedEmail)
              ? (_openBlock(), _createElementBlock("span", _hoisted_5, " 現在変更確認中のメールアドレス： " + _toDisplayString(user.value.unconfirmedEmail), 1 /* TEXT */))
              : _createCommentVNode("v-if", true),
            _createVNode(_component_v_text_field, {
              class: "purple-input",
              label: "メールアドレス",
              placeholder: "メールアドレスを書いてください",
              modelValue: form.value.email,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.value.email) = $event))
            }, null, 8 /* PROPS */, ["modelValue"])
          ]),
          _createElementVNode("div", null, [
            _createVNode(_component_v_text_field, {
              type: "password",
              class: "purple-input",
              label: "パスワード",
              modelValue: form.value.password,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.value.password) = $event))
            }, null, 8 /* PROPS */, ["modelValue"])
          ]),
          _createElementVNode("div", null, [
            _createVNode(_component_v_text_field, {
              type: "password",
              class: "purple-input",
              label: "パスワード（再入力）",
              modelValue: form.value.newPassword,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form.value.newPassword) = $event))
            }, null, 8 /* PROPS */, ["modelValue"])
          ]),
          _createElementVNode("div", null, [
            _createVNode(_component_v_text_field, {
              color: !form.value.isSamePass ? 'red' : 'primary',
              type: "password",
              class: "purple-input",
              label: "パスワード（再入力）",
              modelValue: form.value.newPasswordConfirmation,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((form.value.newPasswordConfirmation) = $event))
            }, null, 8 /* PROPS */, ["color", "modelValue"])
          ]),
          (schoolSetting.value && schoolSetting.value.allowUserEditGroup && !isGuestUpdate.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createVNode(_component_v_select, {
                  items: groups.value,
                  modelValue: form.value.userBlockId,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((form.value.userBlockId) = $event)),
                  "item-text": "name",
                  "item-value": "id",
                  label: "所属",
                  dense: ""
                }, null, 8 /* PROPS */, ["items", "modelValue"])
              ]))
            : _createCommentVNode("v-if", true),
          (errorMessage.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createElementVNode("p", {
                  class: "text-red",
                  innerHTML: errorMessage.value
                }, null, 8 /* PROPS */, _hoisted_8)
              ]))
            : _createCommentVNode("v-if", true),
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_v_btn, {
              class: "update-btn me-2",
              color: "#7DD420",
              onClick: onUpdate
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(isGuestUpdate.value ? 'ユーザー登録する' : 'ユーザー保存する'), 1 /* TEXT */)
              ]),
              _: 1 /* STABLE */
            }),
            (isLoading.value)
              ? (_openBlock(), _createBlock(_component_v_progress_circular, {
                  key: 0,
                  indeterminate: "",
                  color: "green",
                  class: "loading"
                }))
              : _createCommentVNode("v-if", true)
          ])
        ])
      ]),
      _: 1 /* STABLE */
    }),
    _createVNode(_component_v_dialog, {
      transition: "dialog-bottom-transition",
      "max-width": "600",
      modelValue: completeDialog.value,
      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((completeDialog).value = $event))
    }, {
      default: _withCtx(() => [
        _createElementVNode("template", null, [
          _createVNode(_component_v_card, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_toolbar, {
                color: "primary",
                dark: ""
              }, {
                default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                  _createTextVNode("ユーザ更新完了", -1 /* CACHED */)
                ]))]),
                _: 1 /* STABLE */
              }),
              _createElementVNode("div", _hoisted_10, [
                _cache[11] || (_cache[11] = _createElementVNode("div", { class: "text-h5" }, "ありがとございました", -1 /* CACHED */)),
                (user.value.unconfirmedEmail)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _cache[9] || (_cache[9] = _createElementVNode("div", { class: "text-subtitle-1" }, "メールを送りましたので確認してください", -1 /* CACHED */)),
                      _cache[10] || (_cache[10] = _createElementVNode("div", { class: "text-subtitle-1 text-warning" }, "5分後にメールとどかない場合、メールアドレスを再入力しなおしてください", -1 /* CACHED */))
                    ], 64 /* STABLE_FRAGMENT */))
                  : _createCommentVNode("v-if", true)
              ]),
              _createVNode(_component_v_card_actions, { class: "justify-center" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_btn, {
                    depressed: "",
                    color: "primary",
                    onClick: _cache[6] || (_cache[6] = () => { completeDialog.value = false })
                  }, {
                    default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                      _createTextVNode(" 閉じます ", -1 /* CACHED */)
                    ]))]),
                    _: 1 /* STABLE */
                  })
                ]),
                _: 1 /* STABLE */
              })
            ]),
            _: 1 /* STABLE */
          })
        ])
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["modelValue"])
  ]))
}
}

})